/**
 * Limita o comprimento de uma string e adiciona '...' se exceder o limite.
 * @param texto A string a ser verificada.
 * @param limite O número máximo de caracteres (default: 50).
 * @returns A string truncada ou a string original.
 */
export const limitText = (texto: string | null | undefined, limite: number = 50): string => {
  if (!texto) {
    return '-';
  }

  if (texto.length > limite) {
    
    return texto.substring(0, limite) + '...';
  }

  return texto;
}